module.exports = __webpack_public_path__ + "img/mevx.d74f35f4.jpg";